import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgArrowLeft = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.45 6.328c.3-.304.3-.796 0-1.1a.76.76 0 0 0-1.086 0l-6.14 6.222a.78.78 0 0 0-.166.848.8.8 0 0 0 .167.252l6.14 6.222a.76.76 0 0 0 1.085 0c.3-.303.3-.796 0-1.1l-4.83-4.894h16.613A.773.773 0 0 0 22 12a.773.773 0 0 0-.767-.778H4.62z"
      />
    </svg>
  );
};
export default SvgArrowLeft;
